
import React from 'react'
import Layout from "../components/utils/layout";
import Filters from "./filters";
import NamedQueryModule from "../components/data_modules/named_query_module";
import Formatters from "../components/utils/formatters";

const IDT = () => {
    const screenId="IDT"
    const formatters = Formatters()
    const charts = {
        parent_wallet_balances : {
            specialFormatters: {
                parent_account_id: formatters.account_id_link
            }
        },
        cancelled_cards_with_balances : {},
        account_monitoring: {},
        gift_monitoring: {},
        dormant_cards: {
            source: "live"
        },
        dormancy_and_subscription_fee: {
            source: "live"
        },
        inactive_accounts: {},
        failing_to_activate_the_card_within_7_days: {},
        three_or_more_than_transactions_declined_in_3_months: {
            source:"redshift"
        },

    }

    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default IDT
